import { render } from "./Mines.vue?vue&type=template&id=66c98273&scoped=true"
import script from "./Mines.vue?vue&type=script&lang=js"
export * from "./Mines.vue?vue&type=script&lang=js"

import "./Mines.vue?vue&type=style&index=0&id=66c98273&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c98273"]])

export default __exports__